import { createApi } from "@reduxjs/toolkit/query/react";
import { AudiDetailResponse } from "types/index";
import { Params } from "custom-types";
import { axiosBaseQuery } from "@picovico/helpers";

export const audiApi = createApi({
  baseQuery: axiosBaseQuery(),
  tagTypes: ["Audi"],
  reducerPath: "audiApi",
  endpoints: (builder) => ({
    getAudiDetail: builder.query<AudiDetailResponse, Params>({
      query: (queryData) => ({
        name: "show_detail",
        method: "GET",
        params: queryData,
      }),
    }),
    seatSelection: builder.mutation<AudiDetailResponse, Params>({
      query: (queryData) => ({
        name: "seat_selection",
        method: "POST",
        data: queryData,
      }),
    }),
    clearSeatSelection: builder.mutation<AudiDetailResponse, Params>({
      query: (queryData) => ({
        name: "clear_seat_selection",
        method: "POST",
        data: queryData,
      }),
    }),
  }),
});

export const {
  useLazyGetAudiDetailQuery,
  useSeatSelectionMutation,
  useClearSeatSelectionMutation,
} = audiApi;
